<template>
    <transition name="reveal-corner" appear>
        <div class="disconnected" v-if="offline">
            <Disconnected/>
        </div>
    </transition>
</template>

<script type="text/babel">
import Disconnected from '@/assets/disconnected_corner.svg';

export default {
  components: {
    Disconnected,
  },
  data() {
    return {
      offline: false,
    };
  },
  created() {
    window.addEventListener('offline', () => {
      this.offline = true;
    });
    window.addEventListener('online', () => {
      this.offline = false;
    });
  },
};
</script>

<style lang="scss">
    .disconnected {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 5;
        width: 6em;
        line-height: 0;
        filter: drop-shadow(0 0 2px rgba(0,0,0,0.3));
    }

    .reveal-corner-enter-active, .reveal-corner-leave-active {
        transition: transform .5s ease-in-out;
    }
    .reveal-corner-enter, .reveal-corner-leave-to /* .fade-leave-active below version 2.1.8 */ {
        transform: translate(50%, -50%);
    }
</style>
